// @flow
export { default } from './WriteConfigureThumbnail';



// WEBPACK FOOTER //
// ./src/components/write/WriteConfigureThumbnail/index.js